import colors from './colors';

const breakpoints = {
  palm: 321,
  lap: 641,
  lapLarge: 901,
  desk: 1200,
  deskLarge: 1366,
  phoneSmall: 'max-width: 320px',
};

const buttonReset = {
  margin: 0,
  padding: 0,
  width: 'auto',
  border: 'none',
  font: 'inherit',
  outline: 'none',
  color: 'inherit',
  appearance: 'none',
  overflow: 'visible',
  textAlign: 'inherit',
  lineHeight: 'normal',
  fontSmoothing: 'inherit',
  background: 'transparent',
  '&::-moz-focus-inner': {
    border: 0,
    padding: 0,
  },
};

const presets = {
  colors,
  breakpoints,
  buttonReset,
  precision: 5,
  baselineGrid: 8,
  radius: {
    default: '3px',
    rounded: '5px',
    round: '50%',
  },
  animation: {
    curve: {
      default: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
      easeInOutCirc: 'cubic-bezier(0.785, 0.135, 0.150, 0.860)',
      easeInOutExpo: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
    },
    speed: {
      slowest: '800ms',
      slow: '500ms',
      medium: '400ms',
      default: '250ms',
      fast: '125ms',
    },
  },
  zIndex: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900],
};

export default presets;



// WEBPACK FOOTER //
// ./src/utils/presets.js